var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 114,
    viewBox: "0 0 127 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.767 48.2277C102.046 39.0923 98.2202 30.4966 92.6007 23.1388C98.9471 15.453 106.566 8.94344 115.117 3.90131C146.266 76.0419 89.1691 109.253 89.1691 109.253H88.1924C101.945 93.3022 107.33 72.3013 103.767 48.2277Z",
    fill: "#FF93C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7822 71.8716C28.1506 72.3455 41.2196 76.0073 52.9257 82.5591C51.2111 79.1065 49.8915 75.467 48.9926 71.7113C43.7132 49.508 51.0252 21.8541 58.7859 0.799713C69.899 4.70065 81.8304 14.7202 90.0398 26.3428C95.0009 32.9608 98.3801 40.6519 99.9123 48.8133C103.977 76.1466 95.8471 95.9452 82.6487 109.545L82.0679 110.16C82.0679 110.16 54.6151 114.889 33.1544 104.736C8.31494 92.926 2.11166 73.2343 2.11166 73.2343C6.25229 72.1874 10.5167 71.7288 14.7822 71.8716Z",
    fill: "#419FB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0403 26.3431L89.5916 25.7018C76.6052 43.76 69.7598 65.5966 70.0842 87.9298C70.0754 95.7394 70.8626 103.529 72.4336 111.175C75.6592 111.035 78.8753 110.723 82.0684 110.24C82.2796 110.053 82.4644 109.812 82.6756 109.599C95.874 95.9454 103.978 76.1468 99.9128 48.8135C98.3806 40.6522 95.0014 32.961 90.0403 26.3431Z",
    fill: "#265E6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.f64b24c2934356871f99e31ff549e476.svg";
export { ForwardRef as ReactComponent };